import Box from '@mui/material/Box'
import {
    useLocation,
    useNavigate,
} from 'react-router-dom'
import {
    useCallback,
} from 'react'
import {
    ActionBulkComponentFunction,
    ActionComponentFunction,
} from 'app/shared-components/SkyNetDomain/SkyNetDomain.types'
import {
    CommonRoutes,
} from 'app/enums/common.enums'

import CloseButton from '../CloseButton'

import useStyles from './SkyNetDomainFormAction.styles'

type Props = {
    component: ActionComponentFunction | ActionBulkComponentFunction,
    uniqField?: string,
}

const SkyNetDomainFormAction = ({
    component: Component,
    uniqField = 'id',
}: Readonly<Props>) => {
    const {
        classes,
    } = useStyles()
    const {
        pathname,
    } = useLocation()
    const navigate = useNavigate()

    const handleGoBack = useCallback(() => {
        /* calculate path like this because
      the action form is rendered alongside the tabs, not as a child
      — so useResolvedPath('..') won’t work. */
        navigate(pathname.split('/').slice(0, -1).join('/'))
    }, [
        navigate,
        pathname,
    ])

    const handleSuccessRedirect = useCallback((data: Partial<{ id: number }>) => {
        if (data?.[uniqField]) {
            navigate(`../${CommonRoutes.All}/${CommonRoutes.Edit}/${data?.[uniqField]}`)
        } else {
            navigate('..', {
                relative: 'path',
            })
        }
    }, [
        navigate,
        uniqField,
    ])

    return (
        <Box width="100%">
            <div className={classes.header}>
                <CloseButton onClose={handleGoBack} />
            </div>
            <Component
                onSuccess={handleSuccessRedirect}
                onClose={handleGoBack}
            />
        </Box>
    )
}

export default SkyNetDomainFormAction
